export const ItemTypes = {
  STICKY_NOTE: 'stickyNote',
};